import { forwardRef, InputHTMLAttributes, useState } from 'react';

import { ChipsTrigger } from '@hh.ru/magritte-ui-chips-trigger/ChipsTrigger';
import { UncontrolledChipsTriggerProps, ChipsTriggerState } from '@hh.ru/magritte-ui-chips-trigger/types';

const DEFAULT_STATE = {
    value: '',
    chips: [],
};

export const UncontrolledChipsTrigger = forwardRef<
    HTMLInputElement,
    UncontrolledChipsTriggerProps & Omit<InputHTMLAttributes<HTMLInputElement>, keyof UncontrolledChipsTriggerProps>
>(({ state: defaultState = DEFAULT_STATE, onChange, name, ...restProps }, ref) => {
    const [state, setState] = useState<ChipsTriggerState>({ ...defaultState });
    return (
        <>
            <ChipsTrigger
                {...restProps}
                state={state}
                onChange={(newState) => {
                    setState(newState);
                    onChange?.(newState);
                }}
                ref={ref}
            />
            {state.chips.map((chip) => (
                <input type="hidden" name={name} value={chip.value} key={chip.value} />
            ))}
        </>
    );
});

UncontrolledChipsTrigger.displayName = 'UncontrolledChipsTrigger';
